import React from "react";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import {formValidationStyle} from "./FormValidationStyle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import DOMPurify from "dompurify";
import {adminStyles} from "features/Administration/components/adminStyles";
interface AlertInputProps {
  message?: string | any;
  severity?: "success" | "error" | "info" | "warning" | undefined;
  closeIcon?: boolean;
  showAlertBox?: boolean | undefined;
  setShowAlertBox?: any;
  duration?: any;
  isCheckBoxVisible?: boolean;
  isChecked?: boolean;
  handleCheckboxChange?: (checked: boolean) => void;
  checkboxLabel?: string;
}

const FormValidationAlert = ({
  message,
  severity,
  closeIcon,
  showAlertBox = true,
  setShowAlertBox,
  duration,
  isCheckBoxVisible = false,
  isChecked = false,
  handleCheckboxChange,
  checkboxLabel = "",
}: AlertInputProps) => {
  React.useEffect(() => {
    if (showAlertBox) {
      if (duration) {
        const timer = setTimeout(() => {
          setShowAlertBox(false);
        }, duration);
        return () => {
          clearTimeout(timer);
        }; // cleanup
      }
    }
  }, [showAlertBox]);
  const handleClose = () => {
    setShowAlertBox(false);
  };
  return (
    <>
      {showAlertBox && (
        <Stack sx={formValidationStyle.loginStack} spacing={1}>
          <Alert
            sx={formValidationStyle.loginalert}
            severity={severity}
            action={
              closeIcon && (
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              )
            }>
            <Box component={"span"} className="display-flex">
              <Box
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(message),
                }}
              />
              {isCheckBoxVisible && (
                <Box component={"span"} pl={2}>
                  <Checkbox
                    checked={isChecked}
                    sx={adminStyles.marginPaddingZero}
                    onChange={e => {
                      if (handleCheckboxChange) {
                        handleCheckboxChange(e?.target?.checked);
                      }
                    }}
                  />
                  <Box pl={0.5} className="field-form-lbl" component={"span"}>
                    {checkboxLabel}
                  </Box>
                </Box>
              )}
            </Box>
          </Alert>
        </Stack>
      )}
    </>
  );
};

export default FormValidationAlert;
